// @ts-strict-ignore
const tweet = (url) => {
  const windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
  const width = 550;
  const height = 420;
  const winHeight = screen.height || screen.availHeight;
  const winWidth = screen.width || screen.availWidth;

  const left = Math.round((winWidth / 2) - (width / 2));
  let top = 0;

  if (winHeight > height) {
    top = Math.round((winHeight / 2) - (height / 2));
  }
  window.open(url, 'intent', windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
};

export const onTwitterShareClick = (text) => {
  const encodedUrl = encodeURIComponent(`https://healthunlocked.com${window.location.pathname}`);
  const encodedText = encodeURIComponent(text);
  const intentUrl = `https://twitter.com/intent/tweet?related=healthunlocked&hashtags=UnlockYourHealth&url=${encodedUrl}&text=${encodedText}`;
  tweet(intentUrl);
};
